import { useHandlers } from '../../../context/page-context';
import type { StockApiContract } from '../api';

export function useStockApi(): { stockApi: StockApiContract } {
  const { apis } = useHandlers();
  return { stockApi: apis.stock };
}
